import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-5 gap-8 mb-8">
          {/* Brand Column */}
          <div className="space-y-4 mx-auto">
            <a href="/">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_3563a477-4b96-448c-b228-bf27feeae015/artifacts/a3flx1m9_logo-mytharion%20no%20nome.png"
                alt="Mytharion"
                className="h-20 mx-16 w-auto cursor-pointer"
              />
            </a>
            <p className="font-serif-fantasy italic text-m text-muted-foreground">
              « {t("brand.tagline")} »
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading text-sm text-gold mb-4 tracking-wider">
              {t("footer.products")}
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/product/cartomancer_basic"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  Cartomancer
                </a>
              </li>
              <li>
                <span className="text-sm text-muted-foreground/50">
                  {t("footer.vttSoon")}
                </span>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-sm text-gold mb-4 tracking-wider">
              {t("footer.company")}
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/about"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  {t("footer.about")}
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  {t("footer.contact")}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-sm text-gold mb-4 tracking-wider">
              {t("footer.legal")}
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/privacy"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  {t("footer.privacy")}
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  {t("footer.terms")}
                </a>
              </li>
              <li>
                <a
                  href="/cookies"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  {t("footer.cookies")}
                </a>
              </li>
            </ul>
          </div>

          {/* Collab */}
          <div>
            <h4 className="font-heading text-sm text-gold mb-4 tracking-wider">
              {t("footer.collab")}
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/affiliati"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  {t("footer.partners")}
                </a>
              </li>
              <li>
                <a
                  href="/collab"
                  className="text-sm text-muted-foreground hover:text-gold transition-colors"
                >
                  {t("footer.collabWith")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="divider-fantasy mb-8"></div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p data-testid="footer-copyright">
            {t("footer.rights", { year })}
          </p>
          <p className="font-serif-fantasy italic">
            {t("footer.motto")}
          </p>
          <LanguageSelector variant="ghost" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
